<template>
  <main class="container">
    <h1>Privacy Policy</h1>
    <h4>Effective 10/28/14</h4>
    <p>Privacy Notice Table Of Contents:</p>
    <p>
      Our Commitment To Privacy<br>
      The Information We Collect<br>
      How We Use Information<br>
      Our Commitment To Data Security<br>
      Our Commitment To Children's Privacy<br>
      How To Access Or Correct Your Information<br>
      How To Contact Us
    </p>
    <h4>Our Commitment To Privacy</h4>
    <p>Your privacy is important to us. To better protect your privacy we provide this notice explaining our online information practices and the choices you can make about the way your information is collected and used. To make this notice easy to find, we make it available on our homepage and at every point where personally identifiable information may be requested.</p>
    <h4>The Information We Collect:</h4>
    <p>This notice applies to all information collected or submitted on the Pencils For Kids, Inc. website. On some pages, you can make donations, make requests, and register to receive materials. The types of personal information collected at these pages are:</p>
    <ul>
      <li>Name </li>
      <li>Address </li>
      <li>Email address </li>
      <li>Phone number </li>
      <li>Credit/Debit Card Information </li>
      <li>(etc.)</li>
    </ul>
    <p>On some pages, you can submit information about other people. For example, if you order a gift online and want it sent directly to the recipient, you will need to submit the recipient's address. In this circumstance, the types of personal information collected are:</p>
    <ul>
      <li>Phone Number </li>
      <li>(etc.)</li>
    </ul>
    <h4>How We Use Information:</h4>
    <p>We use the information you provide about yourself when placing an order only to complete that order. We do not share this information with outside parties except to the extent necessary to complete that order.</p>
    <p>We use the information you provide about someone else when placing an order only to ship the product and to confirm delivery. We do not share this information with outside parties except to the extent necessary to complete that order.</p>
    <p>We use return email addresses to answer the email we receive. Such addresses are not used for any other purpose and are not shared with outside parties.</p>
    <p>You can register with our website if you would like to receive our updates on our news and services. Information you submit on our website will not be used for this purpose unless you fill out the registration form.</p>
    <p>We use non-identifying and aggregate information to better design our website and to share with sponsors. For example, we may tell a sponsor that X number of individuals visited a certain area on our website, or that Y number of men and Z number of women filled out our registration form, but we would not disclose anything that could be used to identify those individuals.</p>
    <p>Finally, we never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.</p>
    <h4>Our Commitment To Data Security</h4>
    <p>To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online.</p>
    <h4>Our Commitment To Children's Privacy:</h4>
    <p>Protecting the privacy of the very young is especially important. For that reason, we never collect or maintain information at our website from those we actually know are under 13, and no part of our website is structured to attract anyone under 13.</p>
    <h4>How You Can Access Or Correct Your Information</h4>
    <p>You can access all your personally identifiable information that we collect online and maintain by contacting us. We use this procedure to better safeguard your information.</p>
    <p>You can correct factual errors in your personally identifiable information by sending us a request that credibly shows error.</p> <p>To protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.</p>
    <h4>How To Contact Us</h4>
    <p>Should you have other questions or concerns about these privacy policies, please call us at 323-595-1693 or send us an email at <a href="mailto:info@pencilsforkidsinc.com" class="linkwhite">info@pencilsforkidsinc.com</a>
    </p>
  </main>
</template>

<script>
export default {
  name: 'privacy-policy'
}
</script>

<style scoped>
.container {
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// PrivacyPolicy.vue?5b178120